import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Achievements from './Achievements';
import HeroSection from './HeroSection';
import Card from './Card';
import Owl from './Owl';
import Services from './Services';
import Technologies from './Technologies';
import { Helmet } from 'react-helmet';

const KotlinIndex = (props) => {
    const { slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Kotlin App Development Company – Infograins</title>
                <meta name="description" content="Are you looking for a Kotlin App Development Company? So your search is over, we provide the best results to our clients with top-notch Kotlin app development services." />
            </Helmet>
            <HeroSection />
            <Achievements />
            <Services />
            <Technologies />
            {/* <Owl /> */}
            <Card />
        </>
    )
}

export default KotlinIndex